import { AttachmentsSection } from '@components'

import { ReactElement } from 'react'

import { useEInvoicingAddressForm } from '../../../../../../contexts/eInvoicingAddressFormContext'

export const Attachments = (): ReactElement => {
  const { eInvoicingAddressForm } = useEInvoicingAddressForm()
  const { FormItem } = eInvoicingAddressForm

  return (
    <FormItem
      name="attachmentUuids"
      render={({ field: { onChange } }) => <AttachmentsSection onAttachmentsUpload={onChange} />}
    />
  )
}
